import React, {useState, useEffect} from 'react'
import {ModulePanel, ModuleHeader, ModuleBody, ModuleFooter} from 'containers/purchase/modules/module_panel'
import styled from 'styled-components'
import {Label, Input} from 'reactstrap'
import { useTranslation } from 'react-i18next'
import Select from 'react-select'
import languages from 'i18n/languages_3_letter.json'

const LanguageModule = (props) => {
  const {config, machine, status} = props
  const { t, i18n } = useTranslation()
  const [current, send] = machine
  const { locale } = config
  const { ready, language } = current.context

  const languageOptions = config.product.purchase_info.language_selection
    .map((language) => {
      let label

      if (languages[language]?.native) {
        label = languages[language]['native']
      } else {
        label = language
      }

      return {label: label, value: language}
    })

  return (
    <ModulePanel>
      <ModuleHeader status={status} onClick={() => status === 'completed' ? send('REOPEN_LANGUAGESTEP') : null}>
        <div>
          <i className="fa fa-language me-2"/>
          {language ? (
            languages[language].native
          ) : (
            i18n.t('language_module.title')
          )}
        </div>
      </ModuleHeader>
      <ModuleBody status={status}>
        <div className="d-flex justify-content-center align-items-center flex-column">
          <Label className="form-label">{i18n.t('language_module.input_label')}</Label>
          <Select
            id="language"
            className="text-dark w-100"
            options={languageOptions}
            placeholder={i18n.t('language_module.select_placeholder')}
            onChange={(language) => {
              send({type: 'LANGUAGE_CHANGE', language: language})
            }}
          />
        </div>
      </ModuleBody>
      <ModuleFooter {...props}/>
    </ModulePanel>
  )
}

export default LanguageModule
